// extracted by mini-css-extract-plugin
export default {"group":"FormGroup-group-UkYsg","extraSmall":"FormGroup-extraSmall-Xgs0f","small":"FormGroup-small-cZTV8","medium":"FormGroup-medium-HIpH5","large":"FormGroup-large-qJv2k"};